import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import SidebarLogo from "../Image/SideBarIcon.png";
import { Collapse } from "antd";
import "./SideBar.css";
import { faBarsStaggered, faListDots, faCircle } from '@fortawesome/free-solid-svg-icons';
import uWinnLogo from "../../Image/logo192.png";
import { faCircleUser, faDotCircle } from '@fortawesome/free-regular-svg-icons';
// import { } from "@ant-design/icons";
import { faCreditCard } from '@fortawesome/free-regular-svg-icons';
import { faHouse, faEyeSlash, faEye, faBellSlash } from '@fortawesome/free-solid-svg-icons';
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import { faScroll } from "@fortawesome/free-solid-svg-icons";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';
import { faUniversity } from '@fortawesome/free-solid-svg-icons';
import { faInbox } from '@fortawesome/free-solid-svg-icons';
import { faCogs } from '@fortawesome/free-solid-svg-icons';
import { ASSETS_BASE_URL } from "../../config/constants";

const { Panel } = Collapse;
const SidebarLogo = "/images/kc-high-logo.png";

const SidebarItem = ({ to, icon, name, isOpen, className }) => (
  <NavLink to={to} className={`link ${className}`} activeClassName="active">
    <div className="icon">{icon}</div>
    <div style={{ display: isOpen ? "block" : "none" }} className="link_text">
      {name}
    </div>
  </NavLink>
);

const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const handleCollapseToggle = () => {
    setIsOpen(!isOpen);
  };
  const user = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
  const [USERDATA, setUserData] = useState(user || "");

  return (
    <div
      className={`container-fluid side_bar_main_div ${isOpen ? "sidebar-open" : "sidebar-closed"
        }`}
    >
      <div
        style={{ width: isOpen ? "300px" : "70px", position: "relative " }}
        className="sidebar"
      >
        <div className="top_section">
          <img
            src={SidebarLogo}
            className="sidebar_logo"
            alt="KC High"
            style={{
              display: isOpen ? "block" : "none",
              height: "36px",
              width: "auto",
            }}
          />
          <div className="bars">
            <FontAwesomeIcon icon={faBarsStaggered} onClick={handleCollapseToggle} />
          </div>
        </div>
        <div className="my_sidebar_all_section">
          <SidebarItem
            to="/dashboard"
            icon={<FontAwesomeIcon icon={faHouse} />}
            name="Dashboard"
            isOpen={isOpen}
            className="sidebar_heading_text"
          />

          {/* Homepage -- everything shown on kchigh.com's landing page */}
          <React.Fragment>
            {(user?.admin_type === 'Super Admin') && (
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon className="sidebar_collapse_iohomeoutline sidebar_margin" icon={faListDots} />
                    <span
                      className={`sidebar_collapse_iohomeoutline_categoires sidebar_heading_text ${isOpen ? "visible" : "hidden"}`} >Homepage</span>
                  </React.Fragment>
                }
                key="homepage"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"
                  }`}
              >
                <SidebarItem to="/cms/home-banner" icon={<FontAwesomeIcon icon={faCircle} />} name="Home Banner" isOpen={isOpen} />
                <SidebarItem to="/cms/home-banner-images" icon={<FontAwesomeIcon icon={faCircle} />} name="Home Banner Images" isOpen={isOpen} />
                <SidebarItem to="/cms/child-potential" icon={<FontAwesomeIcon icon={faCircle} />} name="Child's Potential" isOpen={isOpen} />
                <SidebarItem to="/cms/features" icon={<FontAwesomeIcon icon={faCircle} />} name="Why Choose Us" isOpen={isOpen} />
                <SidebarItem to="/cms/stats" icon={<FontAwesomeIcon icon={faCircle} />} name="Stats" isOpen={isOpen} />
                <SidebarItem to="/cms/quick-connect" icon={<FontAwesomeIcon icon={faCircle} />} name="Quick Connect" isOpen={isOpen} />
              </Panel>
            </Collapse>
            )}
          </React.Fragment>

          {/* About Us -- founder, leadership, advisory board, partners */}
          <React.Fragment>
            {(user?.admin_type === 'Super Admin') && (
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon className="sidebar_collapse_iohomeoutline" icon={faCircleUser} />
                    <span
                      className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`} >About Us</span>
                  </React.Fragment>
                }
                key="about-us"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"
                  }`}
              >
                <SidebarItem to="/cms/founder" icon={<FontAwesomeIcon icon={faCircle} />} name="About Founder" isOpen={isOpen} />
                <SidebarItem to="/cms/founder-journey" icon={<FontAwesomeIcon icon={faCircle} />} name="Founder Journey" isOpen={isOpen} />
                <SidebarItem to="/cms/team" icon={<FontAwesomeIcon icon={faCircle} />} name="Leadership Team" isOpen={isOpen} />
                <SidebarItem to="/cms/advisory" icon={<FontAwesomeIcon icon={faCircle} />} name="Advisory Board" isOpen={isOpen} />
                <SidebarItem to="/cms/partners" icon={<FontAwesomeIcon icon={faCircle} />} name="Partners" isOpen={isOpen} />
                <SidebarItem to="/cms/roadmap" icon={<FontAwesomeIcon icon={faCircle} />} name="Roadmap" isOpen={isOpen} />
              </Panel>
            </Collapse>
            )}
          </React.Fragment>

          {/* Academics */}
          <React.Fragment>
          {(user?.admin_type === 'Super Admin') && (
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon className="sidebar_collapse_iohomeoutline" icon={faUniversity} />
                    <span
                      className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`} >Academics</span>
                  </React.Fragment>
                }
                key="academics"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"
                  }`}
              >
                <SidebarItem to="/academics" icon={<FontAwesomeIcon icon={faCircle} />} name="Academics Overview" isOpen={isOpen} />
                <SidebarItem to="/academic/banners" icon={<FontAwesomeIcon icon={faCircle} />} name="Banners" isOpen={isOpen} />
                <SidebarItem to="/academic/stages" icon={<FontAwesomeIcon icon={faCircle} />} name="Stages" isOpen={isOpen} />
                <SidebarItem to="/academic/curriculums" icon={<FontAwesomeIcon icon={faCircle} />} name="Curriculums" isOpen={isOpen} />
                <SidebarItem to="/academic/domains" icon={<FontAwesomeIcon icon={faCircle} />} name="Domains" isOpen={isOpen} />
              </Panel>
            </Collapse>
          )}
          </React.Fragment>

          {/* Admissions */}
          <React.Fragment>
          {(user?.admin_type === 'Super Admin' || user?.admin_type === 'admission-admin') && (
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon className="sidebar_collapse_iohomeoutline" icon={faGraduationCap} />
                    <span
                      className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`} >Admissions</span>
                  </React.Fragment>
                }
                key="admissions"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"
                  }`}
              >
                <SidebarItem to="/registrations" icon={<FontAwesomeIcon icon={faCircle} />} name="Registrations" isOpen={isOpen} />
                {(user?.admin_type === 'Super Admin') && (
                <>
                  <SidebarItem to="/admission-process" icon={<FontAwesomeIcon icon={faCircle} />} name="Admission Process" isOpen={isOpen} />
                  <SidebarItem to="/cms/admission-programs" icon={<FontAwesomeIcon icon={faCircle} />} name="Admission Programs" isOpen={isOpen} />
                </>
                )}
              </Panel>
            </Collapse>
          )}
          </React.Fragment>

          {/* Careers & HR */}
          <React.Fragment>
          {(user?.admin_type === 'Super Admin' || user?.admin_type === 'hr-admin') && (
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon className="sidebar_collapse_iohomeoutline" icon={faBriefcase} />
                    <span
                      className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`} >Careers &amp; HR</span>
                  </React.Fragment>
                }
                key="careers-hr"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"
                  }`}
              >
                {(user?.admin_type === 'Super Admin') && (
                <SidebarItem to="/careers" icon={<FontAwesomeIcon icon={faCircle} />} name="Careers" isOpen={isOpen} />
                )}
                <SidebarItem to="/job-applications" icon={<FontAwesomeIcon icon={faCircle} />} name="Job Applications" isOpen={isOpen} />
              </Panel>
            </Collapse>
          )}
          </React.Fragment>

          {/* Exams */}
          <React.Fragment>
          {(user?.admin_type === 'Super Admin') && (
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon className="sidebar_collapse_iohomeoutline" icon={faClipboardList} />
                    <span
                      className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`} >Exams</span>
                  </React.Fragment>
                }
                key="exams"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"
                  }`}
              >
                <SidebarItem to="/ap-courses" icon={<FontAwesomeIcon icon={faCircle} />} name="AP Courses" isOpen={isOpen} />
                <SidebarItem to="/ap-exams" icon={<FontAwesomeIcon icon={faCircle} />} name="AP Exams" isOpen={isOpen} />
                <SidebarItem to="/sat-exams" icon={<FontAwesomeIcon icon={faCircle} />} name="SAT Exams" isOpen={isOpen} />
              </Panel>
            </Collapse>
          )}
          </React.Fragment>

          {/* At KC... -- mirrors the "At KC..." menu on kchigh.com */}
          <React.Fragment>
          {(user?.admin_type === 'Super Admin') && (
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon className="sidebar_collapse_iohomeoutline" icon={faBookOpen} />
                    <span
                      className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`} >At KC...</span>
                  </React.Fragment>
                }
                key="at-kc"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"
                  }`}
              >
                <SidebarItem to="/cms/articles" icon={<FontAwesomeIcon icon={faCircle} />} name="KC Stories" isOpen={isOpen} />
                <SidebarItem to="/at-kc/publications" icon={<FontAwesomeIcon icon={faCircle} />} name="Publications" isOpen={isOpen} />
              </Panel>
            </Collapse>
          )}
          </React.Fragment>

          {/* Site Content -- stories, media, reference content shown across the site */}
          <React.Fragment>
          {(user?.admin_type === 'Super Admin') && (
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon className="sidebar_collapse_iohomeoutline" icon={faScroll} />
                    <span
                      className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`} >Site Content</span>
                  </React.Fragment>
                }
                key="site-content"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"
                  }`}
              >
                <SidebarItem to="/cms/gallery" icon={<FontAwesomeIcon icon={faCircle} />} name="Gallery" isOpen={isOpen} />
                <SidebarItem to="/cms/album" icon={<FontAwesomeIcon icon={faCircle} />} name="Album (Audio)" isOpen={isOpen} />
                <SidebarItem to="/cms/faq" icon={<FontAwesomeIcon icon={faCircle} />} name="FAQs" isOpen={isOpen} />
                <SidebarItem to="/cms/campuses" icon={<FontAwesomeIcon icon={faCircle} />} name="Campuses" isOpen={isOpen} />
                <SidebarItem to="/policies" icon={<FontAwesomeIcon icon={faCircle} />} name="Policies" isOpen={isOpen} />
                <SidebarItem to="/email-templates" icon={<FontAwesomeIcon icon={faCircle} />} name="Email Templates" isOpen={isOpen} />
              </Panel>
            </Collapse>
          )}
          </React.Fragment>

          {/* Feedback & Enquiries */}
          <React.Fragment>
          {(user?.admin_type === 'Super Admin') && (
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon className="sidebar_collapse_iohomeoutline" icon={faInbox} />
                    <span
                      className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`} >Feedback &amp; Enquiries</span>
                  </React.Fragment>
                }
                key="feedback"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"
                  }`}
              >
                <SidebarItem to="/contacts" icon={<FontAwesomeIcon icon={faCircle} />} name="Contacts" isOpen={isOpen} />
                <SidebarItem to="/site-reviews" icon={<FontAwesomeIcon icon={faCircle} />} name="Site Reviews" isOpen={isOpen} />
              </Panel>
            </Collapse>
          )}
          </React.Fragment>

          {(user?.admin_type === 'Super Admin') && (
          <>
            <SidebarItem to="/cms/general-data" icon={<FontAwesomeIcon icon={faCogs} />} name="Site Info & Contact Details" isOpen={isOpen} />
          </>
          )}
          <React.Fragment>
            <SidebarItem
              icon={
                <img
                  src={
                    user?.admin_image
                      ? ASSETS_BASE_URL + user.admin_image
                      : uWinnLogo
                  }
                  alt=""
                  className="user_profile_pic_sidebar"
                  onClick={handleCollapseToggle}
                  width="100px"
                />
              }
              to="#"
              name={
                <div className="sidebar_profile_main_content_section">
                  <React.Fragment>
                    <div className="sidebar_profile_main_content">
                      <div className="user_profile_pic_Admin_name">
                        <span className="user_profile_pic_Admin_panel">
                          {`${user?.admin_first_name} ${user?.admin_last_name}`}
                        </span>{" "}
                        <br />
                        <span className="user_profile_pic_Admin_panel_">
                          Admin
                        </span>
                      </div>
                    </div>
                  </React.Fragment>
                  <React.Fragment>
                    <FontAwesomeIcon icon="fa-regular fa-greater-than" className="side_bar_fagreaterthan"
                      onClick={handleCollapseToggle} />
                  </React.Fragment>
                </div>
              }
              isOpen={isOpen}
              className="custom_profile_class_productList"
            >
            </SidebarItem>
          </React.Fragment>
        </div>
      </div>
      <main>{children}</main>
    </div>
  );
};

export default Sidebar;
